import { graphql } from "react-relay";

export const RemoveReportGroupsMutation = graphql`
  mutation RemoveReportGroupsMutation(
    $names: [String!]!
    $connections: [ID!]!
  ) {
    removeReportGroups(names: $names) @deleteEdge(connections: $connections)
  }
`;
